import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Instagram = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill={fill}
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <path d="M12 0c2.056 0 4 1.944 4 4v8c0 2.056-1.944 4-4 4H4c-2.056 0-4-1.944-4-4V4c0-2.056 1.944-4 4-4h8zm0 2H4c-.935 0-2 1.065-2 2v8c0 .953 1.047 2 2 2h8c.935 0 2-1.065 2-2V4c0-.935-1.065-2-2-2zM8 4c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4zm0 2c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm4.145-3.068c.53 0 .96.43.96.96s-.43.96-.96.96-.96-.43-.96-.96.43-.96.96-.96z" />
    </svg>
  );
};

Instagram.displayName = 'Instagram';
